import { Editor, Element, Range, Transforms } from "slate";
import { HistoryEditor } from "slate-history";

import { NodeTypes } from "../slateTypes";

export class LinkUtils {
  static createLink = (editor: Editor, value: string) => {
    const { selection } = editor;
    const isCollapsed = selection && Range.isCollapsed(selection);
    let url =
      value.includes("http://") || value.includes("https://")
        ? value
        : `https://${value}`;
    const link: any = {
      type: "link",
      url,
      children: isCollapsed ? [{ text: url }] : [],
    };
    if (isCollapsed) {
      Transforms.insertNodes(editor, link);
    } else {
      Transforms.wrapNodes(editor, link, { split: true });
      Transforms.collapse(editor, { edge: "end" });
    }
  };

  static editLink = (editor: Editor, value: string) => {
    const [match] = Editor.nodes(editor, {
      match: (n: any) =>
        !Editor.isEditor(n) &&
        Element.isElement(n) &&
        (n as any).type === NodeTypes.LINK,
    });
    if (match) {
      const [_el, path] = match;
      let url =
        value.includes("http://") || value.includes("https://")
          ? value
          : `https://${value}`;
      Transforms.setNodes(editor, { url }, { at: path });
    }
  };
  static removeMark = (editor: Editor) => {
    HistoryEditor.withoutSaving(editor, () => {
      Editor.removeMark(editor, "prepareLink");
    });
  };
}
